import FormattedMessage from 'I18n/components/FormattedMessage';
import { ApprovalOperation } from 'ui-product-approvals-common';
import { ApprovalButton } from '../button/ApprovalButton';

/**
 * Error affordance shared by the editor approval button surfaces
 * (`ApprovalEditorButtons` and `ApprovalEditorSingleButton`): a disabled
 * "Request approval" button whose tooltip explains that approval information
 * could not be loaded. Sized to match the consumer's primary button via `size`.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const ApprovalEditorErrorButton = ({
  size
}) => /*#__PURE__*/_jsx(ApprovalButton, {
  availableOperation: ApprovalOperation.REQUEST,
  disabled: true,
  disabledReason: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "productApprovals.ApprovalEditorButtons.approvalsUnavailableTooltip"
  }),
  size: size
});